module.exports = __webpack_public_path__ + "img/img3.9984358.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/01/img3.png
// module id = 178
// module chunks = 0